import { Spin } from 'antd';
import React, { ReactNode } from 'react';
import DeloitteLoader from '../DeloitteLoader';
import './LoaderStyles.less';

interface ILoaderProps {
  children: ReactNode;
  loading: boolean;
  loaderName?: string | undefined;
}

const Loader = ({ children, loading, loaderName = undefined }: ILoaderProps) => {
  return (
    <div className="custom-spin-container">
      <Spin
        tip={loaderName}
        spinning={loading}
        className="custom-spin"
        indicator={<DeloitteLoader size={50} />}
      >
        {children}
      </Spin>
    </div>
  );
};

export default Loader;
